import '../styles/ResetPage.css'

/**
 * Catch-all screen for any route other than /reset (e.g. a mistyped or truncated
 * link). Deliberately generic and enumeration-safe — it never confirms whether a
 * token exists.
 */
export default function InvalidLinkPage() {
  return (
    <div className="page">
      <div className="card">
        <header className="card-header">
          <div className="brand">Daikin eQuip</div>
          <h1 className="card-title">Reset your password</h1>
        </header>
        <div className="state-block" role="alert">
          <div className="state-icon state-icon--warn" aria-hidden="true">
            !
          </div>
          <h2 className="state-title">Invalid link</h2>
          <p className="state-message">
            This reset link is invalid. Request a new one from the app.
          </p>
        </div>
      </div>
      <p className="footnote">Daikin eQuip account security</p>
    </div>
  )
}
